/**
 * 应用语言切换：写入 uni / vue-i18n / storage。
 *
 * @module locale/apply-locale
 */

import i18n from '@/locale/index'
import {
  APP_LOCALE_STORAGE_KEY,
  type AppLocale,
  type LocalePageOptions,
  readStoredAppLocale,
  resolveAppLocale,
  syncWotDesignLocale,
} from '@/locale/locale-state'

export type { AppLocale, LocalePageOptions } from '@/locale/locale-state'
export { APP_LOCALE_STORAGE_KEY, SUPPORTED_LOCALES } from '@/locale/locale-state'

// --- 函数 ---

/**
 * 切换全局 locale（uni + vue-i18n），并写入 storage。
 */
export function applyAppLocale(locale: AppLocale): void {
  uni.setLocale(locale)
  i18n.global.locale.value = locale
  uni.setStorageSync(APP_LOCALE_STORAGE_KEY, locale)
  syncWotDesignLocale(locale)
}

/** 解析并应用语言（含持久化） */
export function applyEntryLocaleFromPageOptions(options?: LocalePageOptions): AppLocale {
  const locale = resolveAppLocale(options)
  applyAppLocale(locale)
  return locale
}

/** App 启动：从 storage 恢复语言（主包页无 URL query 时使用） */
export function syncAppLocaleFromStorage(): void {
  const stored = readStoredAppLocale()
  if (!stored)
    return
  applyAppLocale(stored)
}

/** 当前是否为英文界面 */
export function isEnglishAppLocale(): boolean {
  return i18n.global.locale.value === 'en'
}
